import React from "react";
import { useRouter } from "next/router";

import ModalMotion, { AnimateDirection } from "@/components/Molecules/Modal";
import RegistrationForm from "@/containers/ShyftPassBookClass/RegisterPage/RegistrationForm";

import { useAppSelector } from "@/hooks";
import { DEFAULT_URL_ARGUMENTS } from "@/constants";

import { singlePack } from "@/redux/ShyftPassReducer";

import styles from "./PaymentModal.module.scss";
import { generateUrlArguments } from "@/utils";

const PaymentModal = ({ openPaymentModal, setOpenPaymentModal }) => {
  const router = useRouter();
  const { slug = "" } = router?.query || {};

  const { packages } = useAppSelector((state) => state.shyftPass) || {};

  const { title, centerTiming, price } = openPaymentModal;

  const newPrice = price || packages?.[0]?.price;

  let urlParams = "";
  if (typeof window !== "undefined") {
    urlParams = window.location.search;
  }

  const urlsArguments = generateUrlArguments(
    urlParams || DEFAULT_URL_ARGUMENTS
  );
  const formData = {
    title: "Buy a single class pass",
    description: `Please fill in details below to book your class for - <strong>${title}</strong>`,
    showNameField: true,
    namePlaceholder: "Enter your name",
    showPhoneField: true,
    phonePlaceholder: "Phone Number",
    showEmailField: true,
    emailPlaceholder: "Enter E-mail address",
    showCityField: true,
    cityPlaceholder: "City",
    showRequestCallback: true,
    info: "Our weekend workouts are <strong>only for Gurgaon currently.</strong> We will update as we expand to other cities.",
    packages: [
      {
        ...singlePack,
        price: newPrice,
        strikeoutPrice: newPrice,
      },
    ],
    paymentSuccessPath: {
      pathname: `/shyftpass/${slug}/payments/success`,
      search: { class_id: centerTiming },
    },
    paymentFailurePath: `/shyftpass/${slug}/payments/failure`,
    classId: centerTiming,
    urlsArguments,
  };

  return (
    <ModalMotion
      className={styles.detailModal}
      overlayClosable={true}
      onClose={() => setOpenPaymentModal(false)}
      width="500px"
      animateDirection={AnimateDirection.CENTER}
      borderRadius="10px"
      showClose
      iconTopPosition="20px"
      iconRightPosition="20px"
      // btnPos={btnPos}
      bodyPadding={"40px"}
    >
      <div className={styles.paymentModal}>
        <RegistrationForm {...formData} />
      </div>
    </ModalMotion>
  );
};

export default PaymentModal;
